import React, { useEffect, useState, useMemo } from "react";
import { Col, Row, Container } from "react-bootstrap";
import BreadcrumbLayout from "../../component/Breadcrumb";
import PDFGallery from "../../component/PDFGallery";
import { useTranslation } from "react-i18next";
import Animation from "../../assets/images/Animation.gif";
import { PosterGalleryService } from "../../Services/PosterGalleryService";
import PhotoGallerySidebar from "./PhotoGallerySidebar";

export default function PosterGallery() {
  const { t } = useTranslation();

  const menuData =
    t("menu.media-gallery", { returnObjects: true }) || {};

  const posterGalleryService = useMemo(
    () => new PosterGalleryService(),
    []
  );

  const [loadingTblData, setLoadingTblData] = useState(false);
  const [tblData, setTblData] = useState([]);

  useEffect(() => {
    const getPosterGallery = async () => {
      try {
        setLoadingTblData(true);

        const res =
          await posterGalleryService.GetPosterListPublic();

        const data = (res?.data?.table || []).map((item, index) => ({
          key: item.posterId || index + 1,

          posterId: item.posterId,

          posternotes: item.posternotes,

          doc: {
            docMimeType: item.docMimeType,
            docUniqueId: item.docUniqueId,
          },

          Img: {
            imgMimeType: item.imgMimeType,
            imgUniqueId: item.imgUniqueId,
          },

          // Image अभी download नहीं होगी
          ImgUrl: null,
        }));

        setTblData(data);
      } catch (error) {
        console.error(
          "Error loading poster gallery:",
          error
        );

        setTblData([]);
      } finally {
        setLoadingTblData(false);
      }
    };

    getPosterGallery();
  }, [posterGalleryService]);

  return (
    <>
      <BreadcrumbLayout title="Poster Gallery" />

      <Container fluid>
        <Row>

          {/* Sidebar */}
          <PhotoGallerySidebar menuData={menuData} />

          {/* Content */}
          <Col
            md={9}
            className="content order-md-last order-first"
          >
            <Row>

              <Col xs={12} className="heading">
                <h3>
                  {t("breadcrumb.poster-gallery")}
                </h3>
              </Col>

              <Col
                xs={12}
                className="mb-3 mt-3"
              >

                {loadingTblData && (
                  <img
                    src={Animation}
                    alt="Loading"
                  />
                )}

                <PDFGallery
                  galleryItems={tblData}
                  loadingTblData={loadingTblData}
                />

              </Col>

            </Row>
          </Col>

        </Row>
      </Container>
    </>
  );
}